/**
 * Social proof — iter 137 credibility fix
 *
 * All numeric stats and named-customer logos removed. Do NOT add placeholder
 * counts or fictional company names back into this file until we have
 * validated numbers or written permission from a real customer.
 *
 * Empty arrays are intentional. The consuming <SocialProof /> component
 * guards on `.length > 0` and renders NOTHING when both arrays are empty.
 * If you want to restore some framing above the fold, use the honest
 * founding-chapter copy pattern in
 * ``/frontend/src/components/home/FoundingChapterBand.jsx`` instead.
 */

export const stats = [];  // iter 137: no unvalidated counts
export const logos = [];  // iter 137: no placeholder / demo brand names

export const copy = {
    statsHeadline: "",
    logosHeadline: "",
};
